/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GenerateOutputUrlResponseDto { 
    /**
     * Presigned S3 URL for downloading the script execution output
     */
    output_url: string;
}

